import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Inbox, Mail, Tag } from "lucide-react";
import { api, apiErr } from "@/lib/api";

export const MessagesPanel = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/contact").then((r) => setList(r.data)).catch((e) => toast.error(apiErr(e))).finally(() => setLoading(false));
  }, []);

  const fmt = (iso) => {
    try { return new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" }); } catch { return iso; }
  };

  return (
    <div data-testid="panel-messages">
      <h2 className="font-heading font-bold text-2xl mb-6">Pesan Masuk</h2>
      {loading ? (
        <div className="py-20 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-cyan" /></div>
      ) : list.length === 0 ? (
        <div className="py-20 grid place-items-center text-slate-500">
          <Inbox className="w-10 h-10 mb-3" />
          <p>Belum ada pesan masuk.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {list.map((m) => (
            <div key={m.id} data-testid="message-row" className="rounded-2xl border border-white/10 bg-navy-card/50 p-5">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                  <div className="flex items-center gap-2">
                    <p className="font-semibold">{m.name}</p>
                    <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold bg-cyan/15 text-cyan">
                      <Tag className="w-3 h-3" />
                      {m.category}
                    </span>
                  </div>
                  <p className="text-xs text-slate-500 mt-1">{m.email} · {fmt(m.created_at)}</p>
                </div>
                <a href={`mailto:${m.email}`} className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 px-3 py-2 text-xs font-semibold text-cyan hover:border-cyan/50">
                  <Mail className="w-3.5 h-3.5" /> Balas Email
                </a>
              </div>
              <p className="mt-3 text-sm text-slate-300 whitespace-pre-wrap">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
